import React, { useState, useEffect, useLayoutEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Softphone } from "@frejun/softphone-web-sdk";
import "./FrajunWidget.css";
import Tooltip from "@mui/material/Tooltip";
import { tooltipStyleProps } from "services/constants/Styles";
import {
  setFrajunPhoneNumber,
  setFrajunContactName,
  setFrajunAutoInitiate,
  setFrajunContactId,
  setCallCompleteContactId,
  setVisible,
} from "services/Redux/userToken";
import { showToast } from "services/utils/Status";
import { useContactDrawer } from "components/contacts/GlobalContactDrawer";
import { CALL_OUTCOME_OPTIONS } from "components/contacts/callOutcomeOptions";

const Icons = {
  Phone: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  ),
  PhoneOff: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91" />
      <line x1="23" y1="1" x2="1" y2="23" />
    </svg>
  ),
  Mic: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
  ),
  MicOff: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" />
      <path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" />
      <line x1="12" y1="19" x2="12" y2="23" />
      <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
  ),
  Pause: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="6" y="4" width="4" height="16" />
      <rect x="14" y="4" width="4" height="16" />
    </svg>
  ),
  Play: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="5 3 19 12 5 21 5 3" />
    </svg>
  ),
  X: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Headset: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" />
      <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
    </svg>
  ),
  Save: () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
      <polyline points="17 21 17 13 7 13 7 21" />
      <polyline points="7 3 7 8 15 8" />
    </svg>
  ),
  Refresh: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10" />
      <path d="M20.49 15a9 9 0 0 1-14.13 3.36L1 14" />
    </svg>
  ),
  Dialpad: () => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M12 19c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1zM6 3h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zM6 7h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zM6 11h2v2H6zm4 0h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2z" />
    </svg>
  ),
};

const isValidE164 = (num) => /^\+[1-9]\d{6,14}$/.test(num.replace(/\s/g, ''));

// Chrome and Edge both include "Chrome/" in their user-agent string (Edge adds
// "Edg/" on top).  Firefox and Safari do not.  Chromium-based browsers (Brave,
// Opera, Vivaldi) also match — all use Blink's audio pipeline which applies
// echo-cancellation / noise-suppression by default, unlike Firefox / Safari.
const isChromiumBased = () => /Chrome\//.test(navigator.userAgent);

const FAB_SIZE = 56;
const PANEL_WIDTH = 320;
const PANEL_GAP = 20; // space between the FAB and the panel
const DRAG_THRESHOLD = 5; // px of movement before a press becomes a drag
const POS_STORAGE_KEY = "frajun_widget_pos";

const clampFabPos = ({ right, bottom }) => ({
  right: Math.max(0, Math.min(right, window.innerWidth - FAB_SIZE)),
  bottom: Math.max(0, Math.min(bottom, window.innerHeight - FAB_SIZE)),
});

// Open the panel toward whichever side of the screen has more room.
const getPanelPlacement = ({ right, bottom }) => ({
  alignLeft: right + FAB_SIZE / 2 > window.innerWidth / 2,
  below: bottom + FAB_SIZE / 2 > window.innerHeight / 2,
});

const FrajunWidget = () => {
  const dispatch = useDispatch();
  const { domain } = useSelector((state) => state.tokenReducer);
  const visible = useSelector((state) => state.tokenReducer.visible);
  const { openCreateContactDrawer } = useContactDrawer();

  const getSavedPos = () => {
    try {
      const saved = localStorage.getItem(POS_STORAGE_KEY);
      if (!saved) return { right: 20, bottom: 20 };
      return clampFabPos(JSON.parse(saved));
    } catch {
      return { right: 20, bottom: 20 };
    }
  };
  const [showWidget, setShowWidget] = useState(false);
  const [widgetPos, setWidgetPos] = useState(getSavedPos);
  const [panelPlacement, setPanelPlacement] = useState(() => getPanelPlacement(widgetPos));
  const [isDragging, setIsDragging] = useState(false);
  const dragState = useRef({ active: false, moved: false, startX: 0, startY: 0, startRight: 24, startBottom: 24 });
  const currentPosRef = useRef(widgetPos);
  // Set after a drag so the click that follows mouseup doesn't toggle the panel.
  const suppressClickRef = useRef(false);

  // Both the FAB and the panel header are drag handles.
  const handleDragStart = useCallback((e) => {
    if (e.target.closest('button:not(.frajun-fab)')) return;
    if (!e.touches && e.button !== 0) return;
    // Touch keeps its default so a tap still produces a click.
    if (!e.touches) e.preventDefault();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    dragState.current = {
      active: true,
      moved: false,
      startX: clientX,
      startY: clientY,
      startRight: currentPosRef.current.right,
      startBottom: currentPosRef.current.bottom,
    };
    suppressClickRef.current = false;
  }, []);

  const handleDragMove = useCallback((e) => {
    if (!dragState.current.active) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    const dx = dragState.current.startX - clientX;
    const dy = dragState.current.startY - clientY;
    if (!dragState.current.moved) {
      if (Math.hypot(dx, dy) < DRAG_THRESHOLD) return;
      dragState.current.moved = true;
      setIsDragging(true);
    }
    if (e.cancelable) e.preventDefault();
    const newPos = clampFabPos({
      right: dragState.current.startRight + dx,
      bottom: dragState.current.startBottom + dy,
    });
    if (showWidget) {
      // Keep the open panel on-screen on the side it is already showing.
      const minRight = panelPlacement.alignLeft ? PANEL_WIDTH - FAB_SIZE : 0;
      const maxRight = window.innerWidth - (panelPlacement.alignLeft ? FAB_SIZE : PANEL_WIDTH);
      newPos.right = Math.max(minRight, Math.min(newPos.right, maxRight));
    }
    currentPosRef.current = newPos;
    setWidgetPos(newPos);
  }, [showWidget, panelPlacement]);

  const handleDragEnd = useCallback(() => {
    if (!dragState.current.active) return;
    dragState.current.active = false;
    if (!dragState.current.moved) return;
    setIsDragging(false);
    suppressClickRef.current = true;
    try { localStorage.setItem(POS_STORAGE_KEY, JSON.stringify(currentPosRef.current)); } catch {}
  }, []);

  useEffect(() => {
    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchmove', handleDragMove, { passive: false });
    document.addEventListener('touchend', handleDragEnd);
    return () => {
      document.removeEventListener('mousemove', handleDragMove);
      document.removeEventListener('mouseup', handleDragEnd);
      document.removeEventListener('touchmove', handleDragMove);
      document.removeEventListener('touchend', handleDragEnd);
    };
  }, [handleDragMove, handleDragEnd]);

  useEffect(() => {
    const handleResize = () => {
      const next = clampFabPos(currentPosRef.current);
      currentPosRef.current = next;
      setWidgetPos(next);
      setPanelPlacement(getPanelPlacement(next));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Pick the panel's side when it opens (before paint, so it never flashes on
  // the wrong side). It stays put while the open panel is dragged.
  useLayoutEffect(() => {
    if (showWidget) setPanelPlacement(getPanelPlacement(currentPosRef.current));
  }, [showWidget]);

  const reduxPhoneNumber = useSelector((state) => state.tokenReducer.frajunPhoneNumber);
  const reduxContactName = useSelector((state) => state.tokenReducer.frajunContactName);
  const reduxContactId = useSelector((state) => state.tokenReducer.frajunContactId);
  const reduxAutoInitiate = useSelector((state) => state.tokenReducer.frajunAutoInitiate);
  const userIdFromStore = useSelector((state) => state.tokenReducer.userDetails?.id);
  const [frajunEmail, setFrajunEmail] = useState(null);
  const [configLoading, setConfigLoading] = useState(true);
  const clientId = "2Zm8wI2Pc0ozB1Wi8F6BhYq-DlFt_IwEboCaQFSKzcg";

  const backendBaseUrl = domain;

  const softphoneRef = useRef(null);
  const localAudioRef = useRef(null);
  const remoteAudioRef = useRef(null);
  const initLock = useRef(false);

  const activeTokenRef = useRef(null);
  const isSdkInitialized = useRef(false);

  const audioContextRef = useRef(null);
  const ringtoneOscillatorRef = useRef(null);
  const ringtoneIntervalRef = useRef(null);
  const initRetryCountRef = useRef(0);

  // Auth & General States
  const [oauthToken, setOauthToken] = useState(null);
  const [isCheckingToken, setIsCheckingToken] = useState(true);
  const [userClosedWidget, setUserClosedWidget] = useState(false);
  const [hasUnsavedCallLog, setHasUnsavedCallLog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isInitError, setIsInitError] = useState(false);

  const [callMode, setCallMode] = useState("browser");
  const callModeRef = useRef(callMode);
  const callActiveRef = useRef(false);
  const hasUnsavedCallLogRef = useRef(false);
  // Direction of the most recent call; callType is cleared on hangup, before the log is saved.
  const lastCallDirectionRef = useRef("outbound");
  const lookupContactRef = useRef(null);

  // Call Lifecycle States
  const [isInitialized, setIsInitialized] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("+91");
  const [callActive, setCallActive] = useState(false);
  const [callStatus, setCallStatus] = useState(null);
  const [callDetails, setCallDetails] = useState(null);
  // option: store the telephony provider callback id for later logging
  // it may come back as call_id, callId, etc. we'll merge whatever we get
  const [callType, setCallType] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const [isOnHold, setIsOnHold] = useState(false);
  const [showDtmfPad, setShowDtmfPad] = useState(false);
  const [dtmfInput, setDtmfInput] = useState("");

  // Contact resolved from the dialled number via debounced lookup
  const [resolvedContact, setResolvedContact] = useState(null);
  const [isLookingUpContact, setIsLookingUpContact] = useState(false);
  const lookupTimerRef = useRef(null);

  // CRM States (Persist across active call and wrap-up)
  const [showWrapUp, setShowWrapUp] = useState(false);
  const [crmName, setCrmName] = useState("");
  const [crmStatus, setCrmStatus] = useState("");
  const [crmOutcome, setCrmOutcome] = useState("");
  const [crmNotes, setCrmNotes] = useState("");

  // Unknown number prompt
  const [showUnknownPrompt, setShowUnknownPrompt] = useState(false);
  const [pendingCallNumber, setPendingCallNumber] = useState("");

  // Browser recommendation notice — dismissed for this session only
  const [browserNoticeDismissed, setBrowserNoticeDismissed] = useState(
    () => sessionStorage.getItem('frejun_browser_notice_dismissed') === 'true'
  );

  // Keep the widget closed unless the user explicitly opens it.
  // Still render the floating action button while on the CRM page or if a call is active.
  useEffect(() => {
    if (!visible && !callActive) {
      setShowWidget(false);
      setUserClosedWidget(false);
    }
  }, [visible, callActive]);

  useEffect(() => {
    if (visible && !localStorage.getItem('active_call_uuid')) {
      setCallActive(false);
    }
  }, [visible]);

  useEffect(() => {
    if (!callActive) return;
    const timeout = setTimeout(() => {
      setCallActive(false);
      localStorage.removeItem('active_call_uuid');
    }, 90 * 60 * 1000);
    return () => clearTimeout(timeout);
  }, [callActive]);

  useEffect(() => {
    callModeRef.current = callMode;
  }, [callMode]);

  useEffect(() => {
    callActiveRef.current = callActive;
  }, [callActive]);

  useEffect(() => {
    hasUnsavedCallLogRef.current = hasUnsavedCallLog;
  }, [hasUnsavedCallLog]);

  useEffect(() => {
    if (!backendBaseUrl) return;
    const fetchConfig = async () => {
      try {
        const authToken = localStorage.getItem("token");
        const resp = await fetch(`${backendBaseUrl}crm/settings/frejun/`, {
          headers: { Authorization: `token ${authToken}` },
        });
        if (resp.ok) {
          const json = await resp.json();
          if (json?.master_email) {
            setFrajunEmail(json.master_email);
          }
        }
      } catch (e) {
        console.error("Failed to fetch Frejun config:", e);
      } finally {
        setConfigLoading(false);
      }
    };
    fetchConfig();
  }, [backendBaseUrl]);

  useEffect(() => {
    const fetchToken = async () => {
      if (!frajunEmail) {
        setIsCheckingToken(false);
        return;
      }
      try {
        const resp = await fetch(`${backendBaseUrl}frejun/token/`);
        if (resp.ok) {
          const data = await resp.json();
          // Update both state (for UI) and ref (for silent background usage)
          setOauthToken(data.access_token);
          activeTokenRef.current = data.access_token;
        }
      } catch (e) {
        console.error("Backend unreachable for token fetch");
      } finally {
        setIsCheckingToken(false);
      }
    };

    // 1. Initial Fetch
    fetchToken();

    // 2. Silent Background Refresh (every 15 minutes)
    const refreshInterval = setInterval(fetchToken, 900000);

    return () => clearInterval(refreshInterval);
  }, [backendBaseUrl, frajunEmail]);

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== "https://product.frejun.com" || !event.data) return;
      if (event.data.eventName === "oauth-code") {
        const { code, email } = event.data.data;

        // close popup regardless of the result (code may be empty when declined)
        if (authPopupRef.current && !authPopupRef.current.closed) {
          authPopupRef.current.close();
        }

        if (!code) {
          // user declined or something went wrong; show a message and return early
          setErrorMessage("Authorization was not completed.");
          return;
        }

        try {
          const resp = await fetch(`${backendBaseUrl}frejun/exchange/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code, email }),
          });
          if (resp.ok) {
            const data = await resp.json();
            setOauthToken(data.access_token);
            activeTokenRef.current = data.access_token;
            setErrorMessage("");
            showToast("success", "Connected.");
          } else {
            setErrorMessage("Backend failed to exchange token.");
          }
        } catch (e) {
          setErrorMessage("Network error talking to backend.");
        }
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
    if (localStorage.getItem('frejun_debug') === 'true') {
      console.info(
        '[Frejun] Debug logging ON — set localStorage frejun_debug=false to disable'
      );
    }
  }, []);

  useEffect(() => {
    return () => {
      stopRingtone();
    };
  }, []);

  const initializeSoftphone = useCallback(async () => {
    if (!oauthToken) {
      setErrorMessage("Waiting for auth token...");
      setIsInitError(true);
      return;
    }

    // Prevent concurrent initialization runs
    if (isSdkInitialized.current) return;

    setErrorMessage("Initializing softphone...");
    setIsInitError(false);
    setIsInitialized(false);
    setIsConnected(false);

    const token = activeTokenRef.current || oauthToken;
    if (!token) {
      setErrorMessage("No token available to initialize softphone.");
      setIsInitError(true);
      return;
    }

    isSdkInitialized.current = true;

    if (softphoneRef.current) {
      try {
        await softphoneRef.current.logout();
      } catch (err) {
        console.warn("Error during previous softphone logout", err);
      }
      softphoneRef.current = null;
    }

    try {
      const softphone = new Softphone();
      softphoneRef.current = softphone;

      await softphone.login({
        type: "OAuth2.0",
        token,
        email: frajunEmail,
      });

      const audioElements = {
        remote: remoteAudioRef.current,
        local: localAudioRef.current,
      };

      const listeners = {
        onConnectionStateChange: (type, newState) => {
          if (type === "RegisterState")
            setIsConnected(newState === "Registered");
        },
        onCallCreated: (type, details) => {
          if (callModeRef.current !== "browser") return;

          // The SDK supports only one session at a time — when a second call
          // (e.g. an inbound call while we're already on an outgoing one)
          // arrives, the SDK silently reassigns its internal session to the
          // new call, orphaning the previous one. We can't intercept that or
          // queue the new call from here (no pre-accept hook exists), so at
          // minimum log it loudly: the original call's UI state is about to
          // be clobbered, and the missed leg should still show up via the
          // backend's missed-call webhook handling.
          if (callActiveRef.current) {
            console.warn(
              "[FrajunWidget] New call arrived while a call was already active — " +
                "the SDK is replacing the in-progress session. Original call's UI " +
                "state will be overwritten.",
              { newCallType: type, newCallDetails: details }
            );
            setErrorMessage(
              "Another call arrived while this call is active. Save or close the current call log before handling the next call."
            );
            return;
          }

          if (hasUnsavedCallLogRef.current) {
            setErrorMessage(
              "A previous call log is still unsaved. Save it before handling another browser call."
            );
            return;
          }

          setCallActive(true);
          setCallStatus("Ringing");
          setCallType(type);
          setHasUnsavedCallLog(false);
          setCallDetails(details);
          setShowWrapUp(false);

          const isIncoming =
            typeof type === "string" && type.toLowerCase() === "incoming";
          lastCallDirectionRef.current = isIncoming ? "inbound" : "outbound";
          if (isIncoming) {
            // Incoming calls never pass through the dialpad lookup, so find
            // the caller's saved contact here to show the name.
            setCrmName("");
            setResolvedContact(null);
            const digits = String(details?.candidate || "").replace(/\D/g, "");
            if (digits.length >= 10) lookupContactRef.current?.(digits);
          }

          if (typeof type === "string" && type.toLowerCase() === "incoming") {
            startRingtone();
          } else {
            startRingtone();
          }
        },
        onCallRinging: () => {
          if (callModeRef.current !== "browser") return;
          setCallStatus("Connected");
          stopRingtone();
        },
        onCallHangup: () => {
          if (callModeRef.current !== "browser") return;
          stopRingtone();
          setCallActive(false);
          setCallStatus(null);
          setCallType(null);
          setIsMuted(false);
          setIsOnHold(false);
          setShowDtmfPad(false);
          setDtmfInput("");
          setShowWrapUp(true);
          setHasUnsavedCallLog(true);
        },
      };

      // To enable Frejun SDK debug logging for ICE/SIP diagnostics:
      // Open browser console and run:
      //   localStorage.setItem('frejun_debug', 'true')
      // Then refresh the page. To disable:
      //   localStorage.removeItem('frejun_debug')
      // Share the full console output with Frejun support.
      //
      // At logLevel 'debug' the SDK (built on sip.js) emits:
      //   - ICE candidate gathering events (local/remote candidates, pairs)
      //   - SIP INVITE / ACK / BYE / CANCEL messages
      //   - Session state transitions (Establishing → Established → Terminating)
      // These are exactly the lines needed to diagnose one-way audio issues.
      const debugMode = localStorage.getItem('frejun_debug') === 'true';

      await softphone.start(listeners, audioElements, {
        endSessionOnNavigate: false,
        logoutOnNavigate: false,
        logLevel: debugMode ? 'debug' : 'error',
      });

      setIsInitialized(true);
      setErrorMessage("");
      setIsInitError(false);
      initRetryCountRef.current = 0;

    } catch (error) {
      console.error("Softphone connection error:", error);
      isSdkInitialized.current = false;
      setIsInitialized(false);
      setIsConnected(false);
      setIsInitError(true);
      setErrorMessage("Softphone connection failed. Please click Refresh.");

      if (initRetryCountRef.current < 2) {
        initRetryCountRef.current += 1;
        setTimeout(() => initializeSoftphone(), 1200);
      }
    }
  }, [oauthToken, frajunEmail]);

  const handleRefreshSoftphone = async () => {
    if (callActive) return;

    setErrorMessage("Refreshing softphone connection...");
    setIsInitError(false);
    setIsInitialized(false);
    setIsConnected(false);
    isSdkInitialized.current = false;
    initRetryCountRef.current = 0;

    if (softphoneRef.current) {
      try {
        await softphoneRef.current.logout();
      } catch (err) {
        console.warn("Error during refresh logout", err);
      }
      softphoneRef.current = null;
    }

    // Re-fetch the token so a stale/expired token doesn't cause the same failure again.
    try {
      const resp = await fetch(`${backendBaseUrl}frejun/token/`);
      if (resp.ok) {
        const data = await resp.json();
        activeTokenRef.current = data.access_token;
        setOauthToken(data.access_token);
      }
    } catch (e) {
      console.error("Token re-fetch failed during refresh:", e);
    }

    initializeSoftphone();
  };

  useEffect(() => {
    if (!oauthToken) {
      return;
    }

    activeTokenRef.current = oauthToken;
    initializeSoftphone();

    return () => {
      if (softphoneRef.current) {
        softphoneRef.current.logout();
        softphoneRef.current = null;
      }
      isSdkInitialized.current = false;
    };
  }, [oauthToken, initializeSoftphone]);

  // Handle Redux values - populate widget from external component (e.g., ContactDetails)
  useEffect(() => {
    if (reduxPhoneNumber && reduxPhoneNumber !== "+91") {
      // Validate country code +91
      if (!isValidE164(reduxPhoneNumber)) {
        showToast("error", "Please enter your mobile number with country code (e.g. +91 9876543210).");
        dispatch(setFrajunAutoInitiate(false));
        dispatch(setFrajunPhoneNumber(""));
        dispatch(setFrajunContactId(null));
        return;
      }

      // Populate widget with Redux values
      setPhoneNumber(reduxPhoneNumber);
      if (reduxContactName) {
        setCrmName(reduxContactName);
      }
      // Pre-fill resolvedContact directly when contact_id is known — skip debounced lookup
      if (reduxContactId) {
        setResolvedContact({ id: reduxContactId, name: reduxContactName || "" });
      }
      setShowWidget(true);

      // Reset Redux state after populating
      dispatch(setFrajunAutoInitiate(false));
      dispatch(setFrajunPhoneNumber(""));
      dispatch(setFrajunContactName(""));
      dispatch(setFrajunContactId(null));
    }
  }, [reduxPhoneNumber, reduxContactName, reduxContactId, reduxAutoInitiate, dispatch]);

  // Reference to the popup window so we can close it when auth completes
  const authPopupRef = useRef(null);

  const handleLoginClick = () => {
    authPopupRef.current = window.open(
      `https://product.frejun.com/oauth/authorize/?client_id=${clientId}`,
      "FreJun Auth",
      "width=500,height=600",
    );
  };

  const initiateCall = async (num) => {
    lastCallDirectionRef.current = "outbound";
    if (callMode === "browser") {
      if (!softphoneRef.current) return;
      try {
        const result = await softphoneRef.current.makeCall(
          num,
          undefined,
          {
            metadata: { transactionId: `TXN-${Date.now()}` },
          },
        );
        if (result) {
          setCallDetails((prev) => ({ ...prev, ...result }));
        }
      } catch (error) {
        console.error('[Frajunwidget] operation failed:', error);
        showToast("error", "Could not start the call. Please try again.");
      }
    } else {
      try {
        setCallActive(true);
        setCallStatus("Calling via Network...");
        setCallType("Outgoing");
        setHasUnsavedCallLog(false);
        setShowWrapUp(false);
        setCallDetails({ candidate: num });

        const authToken = localStorage.getItem("token");
        const response = await fetch(`${backendBaseUrl}frejun/make-call/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(authToken ? { Authorization: `token ${authToken}` } : {}),
          },
          body: JSON.stringify({
            phone_number: num,
            contact_id: resolvedContact?.id || null,
          }),
        });

        const result = await response.json();
        if (!response.ok) {
          throw new Error(result?.error || "Failed to initiate network call");
        }

        if (result.call_id) {
          setCallDetails({ candidate: num, call_id: result.call_id });
        }

        showToast("success", "Call started.");
        setCallStatus("Call in progress (Network)");
      } catch (error) {
        console.error('[Frajunwidget] operation failed:', error);
        setCallActive(false);
        showToast("error", "Couldn't start the call. Please try again.");
      }
    }
  };

  const handleMakeCall = async () => {
    if (callActive) {
      showToast("error", "A call is already in progress.");
      return;
    }
    if (!phoneNumber.trim()) return;

    const digits = phoneNumber.replace(/\D/g, '');
    if (!resolvedContact && digits.length >= 10) {
      setShowUnknownPrompt(true);
      setPendingCallNumber(phoneNumber);
      return;
    }

    await initiateCall(phoneNumber);
  };

  const handleSaveContactFirst = () => {
    setShowUnknownPrompt(false);
    const num = pendingCallNumber;
    setPendingCallNumber('');
    openCreateContactDrawer(num, async () => {
      await lookupContactByPhone(num.replace(/\D/g, ''));
    });
  };

  const handleCallAnyway = () => {
    setShowUnknownPrompt(false);
    const num = pendingCallNumber;
    setPendingCallNumber('');
    initiateCall(num);
  };
  // Helper function to transition from active Network Call to Wrap-up
  const handleProceedToWrapUp = () => {
    setCallActive(false);
    setCallStatus(null);
    setCallType(null);
    setShowWrapUp(true);
    setHasUnsavedCallLog(true);
  };

  const handleAcceptCall = async () => {
    try {
      stopRingtone();
      softphoneRef.current?.getSession?.accept();
      setCallStatus("Connected");
    } catch (err) {
      console.error('[Frajunwidget] operation failed:', err);
      showToast("error", "Failed to accept");
    }
  };

  const handleEndCall = async () => {
    try {
      stopRingtone();
      softphoneRef.current?.getSession?.end();
    } catch (err) {
      console.error('[Frajunwidget] operation failed:', err);
      showToast("error", "Failed to end call");
    }
  };

  const handleMute = async () => {
    try {
      if (isMuted) {
        await softphoneRef.current?.getSession?.unmute();
        setIsMuted(false);
      } else {
        await softphoneRef.current?.getSession?.mute();
        setIsMuted(true);
      }
    } catch (err) {
      console.error('[Frajunwidget] operation failed:', err);
      showToast("error", "Failed to toggle mute");
    }
  };

  const handleHold = async () => {
    try {
      if (isOnHold) {
        await softphoneRef.current?.getSession?.unhold();
        setIsOnHold(false);
      } else {
        await softphoneRef.current?.getSession?.hold();
        setIsOnHold(true);
      }
    } catch (err) {
      console.error('[Frajunwidget] operation failed:', err);
      showToast("error", "Failed to toggle hold");
    }
  };

  const handleDtmf = (digit) => {
    setDtmfInput((prev) => (prev + digit).slice(-8));
    try {
      softphoneRef.current?.getSession?.sendDTMF(digit);
    } catch (err) {
      // silent — DTMF errors must never interrupt the active call
    }
  };

  const lookupContactByPhone = useCallback(async (digits) => {
    setIsLookingUpContact(true);
    try {
      const authToken = localStorage.getItem("token");
      const resp = await fetch(
        `${backendBaseUrl}crm/contacts/lookup/?phone=${encodeURIComponent(digits)}`,
        { headers: { Authorization: `token ${authToken}` } },
      );
      if (resp.ok) {
        const json = await resp.json();
        setResolvedContact(json.contact || null);
      } else {
        setResolvedContact(null);
      }
    } catch {
      setResolvedContact(null);
    } finally {
      setIsLookingUpContact(false);
    }
  }, [backendBaseUrl]);

  useEffect(() => {
    lookupContactRef.current = lookupContactByPhone;
  }, [lookupContactByPhone]);

  // Show the saved contact's name on the call / wrap-up panel once resolved.
  useEffect(() => {
    const name = resolvedContact?.name || resolvedContact?.company;
    if (name) setCrmName((prev) => prev || name);
  }, [resolvedContact]);

  const stopRingtone = () => {
    if (ringtoneIntervalRef.current) {
      clearInterval(ringtoneIntervalRef.current);
      ringtoneIntervalRef.current = null;
    }

    // Each step is guarded on its own: if stopping the oscillator throws, the
    // audio context must still be released, otherwise startRingtone() sees a
    // stale context and the next call rings silently.
    const oscillator = ringtoneOscillatorRef.current;
    ringtoneOscillatorRef.current = null;
    if (oscillator) {
      try {
        oscillator.stop();
        oscillator.disconnect();
      } catch (err) {
        console.warn("Failed to stop ringtone oscillator", err);
      }
    }

    const audioCtx = audioContextRef.current;
    audioContextRef.current = null;
    if (audioCtx) {
      try {
        Promise.resolve(audioCtx.close()).catch(() => null);
      } catch (err) {
        console.warn("Failed to stop ringtone", err);
      }
    }
  };

  const startRingtone = () => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;

      // A context left over from an earlier call may already be closed; drop
      // it so this call still rings.
      if (audioContextRef.current) {
        if (audioContextRef.current.state !== "closed") return;
        stopRingtone();
      }

      const audioCtx = new AudioContext();

      const createBeep = () => {
        const oscillator = audioCtx.createOscillator();
        const gain = audioCtx.createGain();

        oscillator.type = "sine";
        oscillator.frequency.value = 620;
        gain.gain.value = 0.16;

        oscillator.connect(gain);
        gain.connect(audioCtx.destination);
        oscillator.start();

        ringtoneOscillatorRef.current = oscillator;

        // Stop beep after 280ms to keep it pleasant
        setTimeout(() => {
          if (ringtoneOscillatorRef.current === oscillator) {
            ringtoneOscillatorRef.current = null;
          }
          try {
            oscillator.stop();
            oscillator.disconnect();
          } catch (err) {
            // already stopped by stopRingtone()
          }
        }, 280);
      };

      audioContextRef.current = audioCtx;

      // Play a beep, then repeat until stopped. A suspended context (browser
      // autoplay policy) has to resume before the first beep, or it is lost.
      const begin = () => {
        if (audioContextRef.current !== audioCtx) return;
        createBeep();
        ringtoneIntervalRef.current = setInterval(() => {
          createBeep();
        }, 1400);
      };

      if (audioCtx.state === "suspended") {
        audioCtx.resume().then(begin).catch(() => begin());
      } else {
        begin();
      }
    } catch (err) {
      console.warn("Unable to play ringtone", err);
    }
  };

  // Inside FrajunWidget.js
  const handleSaveCallLog = async () => {
    // Use the active call details if available, otherwise fallback to the typed number
    const targetNumber = callDetails?.candidate || phoneNumber;

    if (!targetNumber || !isValidE164(targetNumber)) {
      showToast("error", "No valid phone number to log.");
      return;
    }

    try {
      // Prefer Redux-stored user id, fallback to localStorage `currentuser` if available
      const fallbackUser = JSON.parse(localStorage.getItem("currentuser") || "{}");
      const user_id = userIdFromStore || fallbackUser?.id || null;

      // Extract the Frejun call_id from SDK event data (field name varies by SDK version)
      const call_id =
        callDetails?.callId ||
        callDetails?.call_id ||
        callDetails?.id ||
        "";

      // The SDK does not always provide a call id (e.g. unanswered calls); the
      // backend then matches the latest call to this number instead.

      const payload = {
        email: frajunEmail,
        user_id,
        call_id,
        candidate_number: targetNumber,
        direction: lastCallDirectionRef.current,
        call_reason: crmStatus || "Outbound",
        call_outcome: crmOutcome || "Completed",
        notes: crmNotes || "No notes provided",
        contact_id: resolvedContact?.id || null,
      };

      const authToken = localStorage.getItem("token");
      const response = await fetch(`${backendBaseUrl}frejun/call-log/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(authToken ? { Authorization: `token ${authToken}` } : {}),
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 404) {
        showToast(
          "error",
          "The call record has not reached the CRM yet. Try Save again in a few seconds, or close this panel to discard the log."
        );
        return;
      }
      if (!response.ok) throw new Error("Backend rejected payload");

      showToast("success", "Call logged.");

      // FIX 1B: delay by 1 s so the backend transaction is visible before the timeline re-fetches
      setTimeout(() => {
        dispatch(setCallCompleteContactId(resolvedContact?.id ?? 'unknown'));
      }, 1000);

      // Reset Widget States
      setShowWrapUp(false);
      setHasUnsavedCallLog(false);
      setErrorMessage("");
      setPhoneNumber("+91");
      setCrmName("");
      setCrmStatus("");
      setCrmOutcome("");
      setCrmNotes("");
      setCallDetails(null);
      setResolvedContact(null);
      setShowUnknownPrompt(false);
      setPendingCallNumber('');
    } catch (error) {
      console.error('[Frajunwidget] operation failed:', error);
      showToast("error", "Failed to save call log.");
    }
  };

  // Reusable CRM Form Block for both views
  const renderCRMForm = () => (
    <div className="frajun-crm-section">
      <select
        className="frajun-select"
        value={crmStatus}
        onChange={(e) => setCrmStatus(e.target.value)}
      >
        <option value="" disabled>
          Select Call Status...
        </option>
        <option value="Answered">Answered</option>
        <option value="Unanswered">Unanswered</option>
        <option value="Busy">Busy</option>
      </select>

      <select
        className="frajun-select"
        value={crmOutcome}
        onChange={(e) => setCrmOutcome(e.target.value)}
      >
        <option value="" disabled>
          Select Call Outcome...
        </option>
        {[
          "interested",
          "brochure_sent",
          "demo_booked",
          "not_interested",
          "callback_requested",
          "invalid_number",
        ].map((value) => {
          const option = CALL_OUTCOME_OPTIONS.find((o) => o.value === value);
          return (
            <option key={value} value={value}>
              {option?.label || value}
            </option>
          );
        })}
      </select>

      <textarea
        className="frajun-textarea"
        placeholder="Add call notes..."
        value={crmNotes}
        onChange={(e) => setCrmNotes(e.target.value)}
      />
    </div>
  );

  const badgeStatus = errorMessage
    ? "error"
    : !isInitialized && oauthToken
      ? "not-initialized"
      : hasUnsavedCallLog
        ? "unsaved"
        : callActive
          ? "active-call"
          : "";

  const canRefresh = !callActive && (!isInitialized || !isConnected || isInitError);

  const fabTitle = showWidget
    ? "Close Softphone"
    : errorMessage
      ? `Error: ${errorMessage}`
      : hasUnsavedCallLog
        ? "Call log not saved - Open Softphone"
        : callActive
          ? "Call in progress - Open Softphone"
          : "Open Softphone";
  // The panel opens above/left of the FAB by default (see CSS); flip it when
  // the FAB has been dragged toward the top or left of the screen.
  const panelStyle = {
    ...(panelPlacement.alignLeft && { left: 0, right: "auto" }),
    ...(panelPlacement.below && { top: FAB_SIZE + PANEL_GAP, bottom: "auto" }),
    maxHeight: Math.max(
      160,
      (panelPlacement.below
        ? widgetPos.bottom
        : window.innerHeight - widgetPos.bottom - FAB_SIZE) - PANEL_GAP - 8
    ),
  };

  if (configLoading || isCheckingToken) return null;

  // Only render the widget if in CRM module or if there's an active call
  if (!visible && !callActive) return null;

  return (
    <div
      className="frajun-widget-container"
      style={{ right: widgetPos.right, bottom: widgetPos.bottom }}
    >
      <audio ref={localAudioRef} id="frajun-local-audio" />
      <audio
        ref={remoteAudioRef}
        id="frajun-remote-audio"
        autoPlay
        controls
        style={{ display: "none" }}
      />
      <Tooltip
        title={isDragging ? "" : fabTitle}
        placement="left"
        arrow
        slotProps={tooltipStyleProps}
      >
        <button
          className={`frajun-fab ${badgeStatus ? `badge-${badgeStatus}` : ""} ${isDragging ? "dragging" : ""}`}
          onMouseDown={handleDragStart}
          onTouchStart={handleDragStart}
          onClick={() => {
            if (suppressClickRef.current) {
              suppressClickRef.current = false;
              return;
            }
            const next = !showWidget;
            setShowWidget(next);
            setUserClosedWidget(!next);
            if (!next) {
              setShowUnknownPrompt(false);
              setPendingCallNumber('');
              if (showWrapUp) {
                setCallActive(false);
                setShowWrapUp(false);
                setHasUnsavedCallLog(false);
                setErrorMessage("");
                localStorage.removeItem('active_call_uuid');
                dispatch(setFrajunContactId(null));
                dispatch(setFrajunPhoneNumber(''));
                dispatch(setFrajunContactName(''));
              }
            }
          }}
          title={fabTitle}
        >
          {showWidget ? <Icons.X /> : <Icons.Phone />}
          {badgeStatus && (
            <span className="frajun-fab-badge" aria-hidden="true" />
          )}
        </button>
      </Tooltip>

      {showWidget && (
        <div className="frajun-panel" style={panelStyle}>
          <div
            className="frajun-header"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: isDragging ? 'grabbing' : 'grab',
              userSelect: 'none',
              touchAction: 'none',
            }}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
          >
            <h3>
              <Icons.Headset /> CAUVER Softphone
            </h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {canRefresh && (
                <button
                  className="frajun-btn btn-outline frajun-refresh-btn"
                  aria-label="Refresh Softphone connection"
                  onClick={handleRefreshSoftphone}
                  disabled={callActive}
                  //style={{ width: '35px', height: '35px', padding: '0' }}
                >
                  <Icons.Refresh />
                </button>
              )}
              <button
                className="frajun-close-btn"
                onClick={() => {
                  setShowUnknownPrompt(false);
                  setPendingCallNumber('');
                  if (showWrapUp) {
                    setCallActive(false);
                    setShowWrapUp(false);
                    setHasUnsavedCallLog(false);
                    setErrorMessage("");
                    localStorage.removeItem('active_call_uuid');
                    dispatch(setFrajunContactId(null));
                    dispatch(setFrajunPhoneNumber(''));
                    dispatch(setFrajunContactName(''));
                  }
                  setShowWidget(false);
                  setUserClosedWidget(true);
                }}
              >
                <Icons.X />
              </button>
            </div>
          </div>

          <div className="frajun-content">
            {errorMessage && <div className="text-danger">{errorMessage}</div>}

            {hasUnsavedCallLog && showWrapUp && (
              <div className="text-danger">
                Call ended but log has not been saved yet.
              </div>
            )}

            {!oauthToken ? (
              <div className="text-center" style={{ padding: "20px 0" }}>
                <p
                  style={{
                    color: "var(--fj-text-muted)",
                    marginBottom: "20px",
                    fontSize: "14px",
                  }}
                >
                  Connect your agent account to make calls directly from the
                  CRM.
                </p>
                <button
                  className="frajun-btn btn-primary"
                  onClick={handleLoginClick}
                >
                  Connect to CAUVER
                </button>
              </div>
            ) : (
              <>
                <div
                  className="frajun-status"
                  style={{
                    display: callActive || showWrapUp ? "none" : "flex",
                  }}
                >
                  <div
                    className={`status-dot ${isInitialized && isConnected ? "connected" : "connecting"}`}
                  />
                  {isInitialized
                    ? isConnected
                      ? "Connected & Ready"
                      : "Connecting to servers..."
                    : "Initializing SDK..."}
                </div>

                {/* VIEW 1: The Dialer */}
                {!callActive && !showWrapUp && (
                  <div>
                    {/* Browser recommendation — only shown to Firefox / Safari users.
                        Chrome and Edge apply echo-cancellation by default; Firefox and
                        Safari do not, causing background noise. Hidden once dismissed
                        (sessionStorage) and never shown during an active call. */}
                    {!isChromiumBased() && !browserNoticeDismissed && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '6px 10px',
                          marginBottom: '10px',
                          background: '#fff8e1',
                          border: '1px solid #ffe082',
                          borderRadius: '6px',
                          fontSize: '12px',
                          color: '#5d4037',
                        }}
                      >
                        <span>For best call quality, use Chrome or Edge.</span>
                        <button
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: '0 0 0 8px',
                            color: '#5d4037',
                            lineHeight: 1,
                            fontSize: '16px',
                          }}
                          aria-label="Dismiss browser recommendation"
                          onClick={() => {
                            sessionStorage.setItem('frejun_browser_notice_dismissed', 'true');
                            setBrowserNoticeDismissed(true);
                          }}
                        >
                          ×
                        </button>
                      </div>
                    )}
                    <div
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        gap: "15px",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <input
                          type="radio"
                          value="browser"
                          checked={callMode === "browser"}
                          onChange={(e) => setCallMode(e.target.value)}
                          disabled={callActive || showWrapUp}
                        />
                        Browser Call
                      </label>
                      <label
                        style={{
                          fontSize: "14px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <input
                          type="radio"
                          value="network"
                          checked={callMode === "network"}
                          onChange={(e) => setCallMode(e.target.value)}
                          disabled={callActive || showWrapUp}
                        />
                        Network Call
                      </label>
                    </div>
                    {crmName && (
                      <div style={{ marginBottom: "10px", fontSize: "14px", color: "var(--fj-text-muted)" }}>
                        Calling: <strong>{crmName}</strong>
                      </div>
                    )}
                    <input
                      type="tel"
                      className="frajun-input"
                      placeholder="+91 Mobile Number"
                      value={phoneNumber}
                      onChange={(e) => {
                        const val = e.target.value;
                        setPhoneNumber(val);
                        setResolvedContact(null);
                        if (lookupTimerRef.current) clearTimeout(lookupTimerRef.current);
                        const digits = val.replace(/\D/g, '');
                        if (digits.length >= 7) {
                          lookupTimerRef.current = setTimeout(
                            () => lookupContactByPhone(digits), 400
                          );
                        }
                      }}
                      disabled={callMode === "browser" && !isConnected}
                    />
                    {phoneNumber.replace(/\D/g, '').length >= 10 && !phoneNumber.startsWith('+') && (
                      <div style={{ fontSize: '12px', color: 'var(--fj-text-muted)', marginTop: '4px' }}>
                        Add country code to call via CRM (e.g. +91 {phoneNumber})
                      </div>
                    )}
                    {isLookingUpContact && (
                      <div style={{ fontSize: '12px', color: 'var(--fj-text-muted)', marginTop: '4px' }}>
                        Looking up contact…
                      </div>
                    )}
                    {!isLookingUpContact && resolvedContact && (
                      <div style={{ marginTop: '6px', padding: '6px 8px', background: 'var(--fj-surface)', borderRadius: '6px', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <span style={{ fontWeight: 600 }}>{resolvedContact.name}</span>
                        {resolvedContact.company && (
                          <span style={{ color: 'var(--fj-text-muted)' }}>{resolvedContact.company}</span>
                        )}
                        {resolvedContact.status && (
                          <span style={{ fontSize: '11px', padding: '1px 6px', background: '#e8f5e9', color: '#2e7d32', borderRadius: '10px' }}>
                            {resolvedContact.status}
                          </span>
                        )}
                      </div>
                    )}
                    {!isLookingUpContact && !resolvedContact && phoneNumber.replace(/\D/g, '').length >= 10 && !showUnknownPrompt && (
                      <div style={{ fontSize: '11px', color: 'var(--fj-text-muted)', marginTop: '4px' }}>
                        Unknown number — will save as new call record after call
                      </div>
                    )}
                    {showUnknownPrompt && (
                      <div style={{
                        margin: '8px 0',
                        padding: '10px 12px',
                        background: '#FAEEDA',
                        border: '0.5px solid #FAC775',
                        borderRadius: '4px',
                      }}>
                        <p style={{ fontSize: '12px', color: '#633806', fontWeight: 500, margin: '0 0 8px 0' }}>
                          Unknown number — no contact found
                        </p>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button
                            className="frajun-btn btn-outline"
                            style={{ fontSize: '11px', borderColor: '#1D9E75', color: '#1D9E75', padding: '4px 10px' }}
                            onClick={handleSaveContactFirst}
                          >
                            + Save contact first
                          </button>
                          <button
                            className="frajun-btn"
                            style={{ fontSize: '11px', color: '#633806', background: 'transparent', border: 'none', padding: '4px 6px', cursor: 'pointer' }}
                            onClick={handleCallAnyway}
                          >
                            Call anyway
                          </button>
                        </div>
                      </div>
                    )}
                    <button
                      className="frajun-btn btn-success"
                      onClick={handleMakeCall}
                      disabled={
                        callActive ||
                        (callMode === "browser" && !isConnected) ||
                        !phoneNumber.trim() ||
                        !isValidE164(phoneNumber)
                      }
                    >
                      <Icons.Phone /> Call Now
                    </button>
                  </div>
                )}

                {/* COMBINED VIEW 2 & 3: Active Call OR Wrap-Up */}
                {(callActive || showWrapUp) && (
                  <div>
                    {showWrapUp && (
                      <div className="frajun-wrapup-header">
                        Log Call Details
                      </div>
                    )}

                    <div className="frajun-call-info">
                      <input
                        type="text"
                        className="frajun-input frajun-name-input"
                        placeholder="Contact Name (Optional)"
                        value={crmName}
                        onChange={(e) => setCrmName(e.target.value)}
                      />
                      <p className="call-number">
                        {callDetails?.candidate || phoneNumber}
                      </p>

                      {callActive && (
                        <p className="call-state">
                          {callType === "Incoming"
                            ? "Incoming Call"
                            : "Outgoing Call"}{" "}
                          • {callStatus}
                        </p>
                      )}
                    </div>

                    {/* Active Call Actions */}
                    {callActive && callMode === "browser" && (
                      <>
                        <div className="frajun-controls-grid">
                          {callType === "Incoming" &&
                            callStatus === "Ringing" && (
                              <button
                                className="frajun-btn btn-success control-btn-full"
                                onClick={handleAcceptCall}
                              >
                                <Icons.Phone /> Accept
                              </button>
                            )}
                          <button
                            className={`frajun-btn btn-outline ${isMuted ? "active" : ""}`}
                            onClick={handleMute}
                          >
                            {isMuted ? <Icons.MicOff /> : <Icons.Mic />} Mute
                          </button>
                          <button
                            className={`frajun-btn btn-outline ${isOnHold ? "active" : ""}`}
                            onClick={handleHold}
                          >
                            {isOnHold ? <Icons.Play /> : <Icons.Pause />} Hold
                          </button>
                          <button
                            className={`frajun-btn btn-outline control-btn-full ${showDtmfPad ? "active" : ""}`}
                            onClick={() => setShowDtmfPad((prev) => !prev)}
                            aria-label="Toggle dialpad"
                          >
                            <Icons.Dialpad /> Dialpad
                          </button>
                          <button
                            className="frajun-btn btn-danger control-btn-full"
                            onClick={handleEndCall}
                          >
                            <Icons.PhoneOff /> End Call
                          </button>
                        </div>

                        {showDtmfPad && (
                          <div className="frajun-dtmf-wrapper">
                            <div className="frajun-dtmf-display">
                              {dtmfInput || " "}
                            </div>
                            <div className="frajun-keypad">
                              {["1","2","3","4","5","6","7","8","9","*","0","#"].map((d) => (
                                <button
                                  key={d}
                                  className="keypad-btn"
                                  onClick={() => handleDtmf(d)}
                                >
                                  {d}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    {callActive && callMode === "network" && (
                      <div style={{ marginTop: "15px", textAlign: "center" }}>
                        <p
                          style={{
                            fontSize: "13px",
                            color: "var(--fj-text-muted)",
                            marginBottom: "15px",
                          }}
                        >
                          This call is being routed to your mobile network.
                          Click below when the call has ended to save your
                          notes.
                        </p>
                        <button
                          className="frajun-btn btn-danger control-btn-full"
                          onClick={handleProceedToWrapUp}
                        >
                          <Icons.PhoneOff /> Simulate Call End / Log Notes
                        </button>
                      </div>
                    )}

                    {/* The shared CRM Forms Block */}
                    {renderCRMForm()}

                    {/* Wrap-Up Save Button */}
                    {showWrapUp && (
                      <button
                        className="frajun-btn btn-primary"
                        onClick={handleSaveCallLog}
                        style={{ marginTop: "12px" }}
                      >
                        <Icons.Save /> Save & Close
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default FrajunWidget;
